import { Tabs, Tab, Box, } from '@mui/material';

const Navbar = ({ tabValue, onTabChange }) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={onTabChange}
          textColor="primary"
          indicatorColor="primary"
          centered
        >
          <Tab label="array" value="[array]" />
          <Tab label="compare" value="comparison" />
          <Tab label="json" value="json{}" />
          <Tab label="xml" value="<xml>" />
        </Tabs>
      </Box>
    </Box>
  );
};

export default Navbar;
